import { render, staticRenderFns } from "./ProfileMasterData.vue?vue&type=template&id=a1b2a8b2&scoped=true&"
import script from "./ProfileMasterData.vue?vue&type=script&lang=js&"
export * from "./ProfileMasterData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b2a8b2",
  null
  
)

export default component.exports